import React, { useRef, useState } from 'react'

const Modal = ({ children, onClose }) => {
  const modalRef = useRef(null)
  const [mouseDownOutside, setMouseDownOutside] = useState(false)

  const handleMouseDown = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setMouseDownOutside(true)
    } else {
      setMouseDownOutside(false)
    }
  }

  const handleMouseUp = (e) => {
    if (mouseDownOutside && modalRef.current && !modalRef.current.contains(e.target)) {
      onClose()
    }
    setMouseDownOutside(false)
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <div
        ref={modalRef}
        className="bg-white rounded-xl shadow-lg w-full max-w-3xl mx-4"
      >
        {children}
      </div>
    </div>
  )
}

export default Modal
